export default __webpack_public_path__ + "static/3-1b2f053da97a56cc6e33d86acfac4c52.jpg";